function moveNewsletter() {
  const newsletter = document.querySelector('.newsletter');
  const columnList = document.querySelectorAll('.column-link div');
  const lastColumn = columnList[columnList.length - 1];
  const footerContent = document.querySelector('.footer-content');

  if (!lastColumn) return;

  if (window.innerWidth >= 992 && newsletter && !newsletter.contains(lastColumn)) {
    lastColumn.appendChild(newsletter);
  } else {
    footerContent.appendChild(newsletter);
  }
}
const debounce = (func, wait) => {
  let timeout;
  return function (...args) {
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(this, args), wait);
  };
};

const debouncedInit = debounce(moveNewsletter, 500);

document.addEventListener('DOMContentLoaded', moveNewsletter);

window.addEventListener('resize', debouncedInit);
